import './iam-avatar/iam-avatar.component';
import './iam-avatar/iam-avatar.scss';
